import './model-subnav.scss';

const NAVBAR_HEIGHT = 60;
const SIDEBAR_BREAKPOINT = 960;

function isDesktopSidebar() {
	return window.matchMedia( `(min-width: ${ SIDEBAR_BREAKPOINT }px)` ).matches;
}

function getNavbarHeight() {
	const sticky = document.querySelector( '.js-headerSticky' );
	if ( sticky && sticky.offsetHeight > 0 ) {
		return sticky.offsetHeight;
	}
	const navbar = document.querySelector( '.tm-navbar' );
	return ( navbar && navbar.offsetHeight > 0 ) ? navbar.offsetHeight : NAVBAR_HEIGHT;
}

function initModelSubnav() {
	const nav = document.querySelector( '.js-modelSubnav' );
	if ( ! nav ) {
		return;
	}

	const links = nav.querySelectorAll( '.js-modelSubnavLink' );
	if ( ! links.length ) {
		return;
	}

	function getScrollOffset() {
		const navbarH = getNavbarHeight();

		// On desktop the subnav sits as a sidebar, so only compensate for header height.
		if ( isDesktopSidebar() ) {
			return navbarH + 16;
		}

		const subnavH = nav.offsetHeight;
		return navbarH + subnavH + 16;
	}

	// Smooth scroll naar sectie, rekening houdend met navbar + subnav hoogte
	links.forEach( ( link ) => {
		link.addEventListener( 'click', ( e ) => {
			const targetId = link.dataset.target;
			const target = targetId ? document.getElementById( targetId ) : null;
			if ( ! target ) {
				return;
			}
			e.preventDefault();
			const top = target.getBoundingClientRect().top + window.scrollY - getScrollOffset();
			window.scrollTo( { top, behavior: 'smooth' } );
		} );
	} );

	// Actieve link bijhouden via scroll
	const targets = Array.from( links )
		.map( ( link ) => document.getElementById( link.dataset.target ) )
		.filter( Boolean );

	if ( ! targets.length ) {
		return;
	}

	const setActive = ( id ) => {
		links.forEach( ( link ) => {
			link.classList.toggle( 'is-active', link.dataset.target === id );
		} );
	};

	const updateActive = () => {
		const offset = getScrollOffset();

		let activeId = null;
		targets.forEach( ( target ) => {
			if ( target.getBoundingClientRect().top <= offset ) {
				activeId = target.id;
			}
		} );

		if ( activeId ) {
			setActive( activeId );
		} else if ( targets.length ) {
			setActive( targets[0].id );
		}
	};

	window.addEventListener( 'scroll', updateActive, { passive: true } );
	updateActive();
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initModelSubnav );
} else {
	initModelSubnav();
}
